if($('header#header').length){
    if(!$('footer#footer').length){
        $(document).ready(function () {
            if(sessionStorage.loadedFooter) {
              $('.overall-wrapper').append('<footer id="footer">'+sessionStorage.loadedFooter+'</footer>')
              customHeader()
            } else {
              $.ajax({
                type: "GET",
                dataType: "html",
                timeout: 1e4,
                cache: !0,
                url: "/",
                success: function(e) {
                    var a = shoptet.common.createDocumentFromString(e),
                    t = $(a).find("footer#footer").html();
                    null !== t && ($('.overall-wrapper').append('<footer id="footer">'+t+'</footer>'))
                    sessionStorage.loadedFooter = $("footer#footer").html();
                    customHeader()
                    }
                });
            }
        })
    }
    else{
        customHeader()
    }
    
    
    $('<span class="close"></span>').appendTo('.login-widget .popup-widget-inner');    
    $(document).on("click", ".login-widget .popup-widget-inner .close", function(){
        $('body').removeClass('user-action-visible login-window-visible')
    })
    
   
    function customHeader(){
        $('#customerLogin').prepend('<div class="registerPlus">'+registrationBenefits+'</div>')
    }   
}